/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
const MANIFEST_URL = 'https://www.streetwall.art/tonconnect-manifest.json';
export default function TonConnectProvider({ children }) {
  return (
    <TonConnectUIProvider manifestUrl={MANIFEST_URL}>
      {children}
    </TonConnectUIProvider>
  );
}
